import React, { useEffect, useState } from 'react';
import {useLocation} from "react-router-dom";

const ThankYouPage = () => {
    function IconImage({ src, alt, className }) {
        return <img loading="lazy" src={src} alt={alt} className={className} />;
    }

    const location = useLocation();

    const searchParams = new URLSearchParams(location.search);
    //const errorCode = searchParams.get('errorCode') || 'Unknown error code';
    //const amount = searchParams.get('amount');
    const transID = searchParams.get('id');
    const txId = searchParams.get('txId');
    const env = searchParams.get('userData9');
    const [amount, setAmount] = useState();
    const backendUrl = process.env.REACT_APP_BACKEND_URL;

    useEffect(() =>{
        
        const queryTran = async () => {
            try {
                const response = await fetch(`${backendUrl}/api/qa/query-tran`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ 
                        id: txId,
                        env:env
                    })
                });
    
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
    
                const data = await response.json();
                setAmount(data.amount/100)
            } catch (error) {
                console.log("Something happened: ", error);
            }
        };
    
        queryTran();
    },[])
    

    return (
        <main className="flex flex-col items-center w-full bg-neutral-50 min-h-screen">  {/* Background applies to the whole page */}
            <div className="flex flex-col items-center px-5 pb-20 w-full max-w-[480px]">  {/* Content is centered and max-width is 480px */}
                <img
                    loading="lazy"
                    src={`${process.env.PUBLIC_URL}/logo.png`} // Replace with your actual logo URL
                    alt="Company logo"
                    className="mt-4 w-16 aspect-[1.06]"
                />
                <div className="mt-24 w-60 text-2xl tracking-wide text-center text-gray-600">
                    תשלום בסך <span className="font-bold">₪{amount}</span>
                    <br />
                    עבר בהצלחה!
                </div>
                <IconImage
                    src={`${process.env.PUBLIC_URL}/success.png`}
                    alt="Success Icon"
                    className="mt-7 max-w-full aspect-square w-[127px]"
                />

                <div className="mt-5 text-2xl font-semibold tracking-wide text-center text-green-500">{transID}</div>
                <div className="mt-1 text-sm font-semibold tracking-wide text-center text-gray-600">מזהה עסקה</div>
                <div className="mt-24 mb-14 text-lg font-semibold tracking-wide text-center text-black">
                    אפשר לסגור את הדף
                    <br />
                    ולחזור לצ'ט.
                </div>
            </div>
        </main>
    );
};

export default ThankYouPage;
